import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FREQUENCIES } from '../../../data/PredictionManager';
import { getSpinSystems } from '../../../data/data1d/spectrumSimulation';
import Label from '../../elements/Label';
import Select from '../../elements/Select';
import FormikNumberInput from '../../elements/formik/FormikNumberInput';
import FormikSelect from '../../elements/formik/FormikSelect';
const SPIN_SYSTEMS = getSpinSystems().map((key) => ({
    label: key,
    value: key,
}));
const labelStyle = {
    label: { fontSize: '10px' },
    wrapper: { display: 'flex', alignItems: 'center', height: '100%' },
    container: { padding: '0 5px', height: '100%' },
};
const selectStyles = { width: '100%', minWidth: '75px', fontSize: '10px' };
export default function SpectrumSimulationSimpleOptions({ onSpinSystemChange, spinSystem, }) {
    return (_jsxs("div", { style: {
            display: 'flex',
            justifyContent: 'flex-end',
            flex: '1',
            padding: '0 10px',
        }, children: [_jsx(Label, { title: "Spin system", style: labelStyle, children: _jsx(Select, { items: SPIN_SYSTEMS, style: selectStyles, onChange: onSpinSystemChange, value: spinSystem }) }), _jsx(Label, { title: "Frequency", style: labelStyle, children: _jsx(FormikSelect, { items: FREQUENCIES, style: selectStyles, name: "options.frequency" }) }), _jsxs(Label, { title: "Line Width", style: labelStyle, children: [_jsx(FormikNumberInput, { name: "options.lineWidth", type: "number", style: { margin: 0, width: '40px' } }), _jsx("span", { style: { padding: '0 5px' }, children: "Hz" })] })] }));
}
